// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"112":"652cc9f550a8d875","785":"005c63b6e3488300"}[chunkId] + ".js";
};